import { makeStyles } from 'tss-react/mui';

export const MODAL_MAX_WIDTH = 611;

export const useStyles = makeStyles()((theme) => ({
  modal: {
    width: `min(70vw, ${MODAL_MAX_WIDTH}px) !important`,
    minHeight: 'initial',
    [theme.breakpoints?.down('md')]: {
      borderRadius: 10,
      width: '85vw !important',
    },
  },
}));
